export const DASHBOARD = 'dashboard';
export const DASHBOARD1 = 'dashboard1';
export const ADMIN_DASHBOARD = 'admin-dashboard';
export const SOS_REQUEST = 'SOS Request';
export const SOS_REGISTRATION_REQUEST = 'SOS Registration Request';
export const SOS_RESPONDER_REQUEST = 'SOS Responder Request';

export const RESPONDER_WALLET = 'responder_wallet';
export const RESPONDER_ESIM = 'responder_esim';
export const RESPONDER_RIDE = 'responder_ride';
export const RESPONDER_VEHICLE = 'responder_vehicle';
export const CUSTOMER_WALLET = 'customer_wallet';

export const USERS = 'users';
export const CUSTOMERS = 'customers';
export const RESELLERS = 'resellers';
export const ADVERTISERS = 'advertisers';
export const RESPONDERS = 'responders';

export const TRANSACTIONS = 'transactions';
export const WALLET_TRANSACTIONS = 'wallet';
export const SOS_TRANSACTIONS = 'sos';
export const ESIM_TRANSACTIONS = 'esim';

export const SYSTEM = 'system';
export const STAFF = 'staff';
export const ACCOUNT_SETTINGS = 'account_settings';
export const ROLES = 'roles';
export const TICKET = 'tickets';
export const TICKET_VIEW = 'ticket_view';
export const TICKETS_SUBMIT_REPLY = 'tickets_submit_reply';

export const SYSTEM_SETTINGS = 'settings_system_settings';
export const CLIENT_SETTINGS = 'client_settings';
export const SYSTEM_COUNTRIES = 'system_countries';
export const BUNDLES = 'bundles';
export const LIVE_TV = 'live_tv';
export const LIVE_RADIO = 'live_radio';
export const ADDRESS_COUNTRIES = 'address_countries';
export const ESIM_NUMBERS = 'esim_numbers';
export const CALL_RATES = 'call_rates';

export const THIRD_PARTY_SETTINGS = 'settings_third_party_settings';
export const VOIP_SWITCH_SETTINGS = 'voIP_Switch_Settings';
export const SOS_SETTINGS = 'sos_settings';
export const SILICON_SETTINGS = 'silicon_settings';
export const FLEX_PAY_SETTINGS = 'flex_pay_settings';
export const DT_ONE_SETTINGS = 'dt_one_settings';
export const THUNES_SETTINGS = 'thunes_settings';
export const OTT_VOUCHER_SETTINGS = 'ott_voucher_settings';
export const OTT_DENOMINATIONS = 'ott_denominations';

export const SYSTEM_LOGS = 'system_logs';
export const ACTIVITY_LOGS = 'activity_logs';
export const VOIP_SWITCH_LOGS = 'voip_switch_logs';
export const SOS_LOGS = 'sos_logs';
export const DTONE_LOGS = 'dtone_logs';
export const FLEXPAY_LOGS = 'flexpay_logs';
export const OTT_VOUCHER_LOGS = 'ott_voucher_logs';
export const SILICON_LOGS = 'silicon_logs';
export const THUNES_LOGS = 'thunes_logs';
